import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [userName, setUserName] = useState("User");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const storedUser = JSON.parse(localStorage.getItem("loggedInUser"));

  //   if (storedUser && storedUser.name) {
  //     setUserName(storedUser.name);
  //   } else {
  //     setUserName("Guest"); 
  //   }

  //   // ✅ Close dropdown when clicking outside
  //   const handleClickOutside = (e) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
  //       setIsDropdownOpen(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);


useEffect(() => {
  const email = localStorage.getItem("email");

  let displayName = "Guest";

  if (email) {
    displayName = email
      .split("@")[0]
      .replace(/[._]/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  setUserName(displayName);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () =>
    document.removeEventListener("mousedown", handleClickOutside);
}, []);






  // ✅ Full logout
  const handleLogout = () => {
    localStorage.clear(); // Clear token + user data
    navigate("/chennai-login"); // Redirect to login page
  };

const handleProfile = () => {
  const storedUser = JSON.parse(localStorage.getItem("loggedInUser"));
  
  if (storedUser?.role === "admin") {
    navigate("/chennaiadminprofile"); // Admin profile page
  } else {
    navigate("/chennaiprofile"); // User profile page
  }
};

  return (
    <nav className="w-full bg-white  shadow-lg shadow-black/20 h-16 px-4 sm:px-8 md:px-12 flex items-center justify-between">
      {/* Left - Logo */}
      <div className="flex items-center gap-2 h-full ml-6 md:ml-20">
        <img
          src="http://res.cloudinary.com/dt8emxboh/image/upload/v1762323243/zwibh7dibwkuwxhblqkc.png"
          alt="Logo"
          className="h-10 w-auto object-contain"
        />
      </div>

      {/* Right - User Info */}
      <div className="relative flex items-center gap-3  mr-6 md:mr-20" ref={dropdownRef}>
        <p className="text-gray-700 font-medium hidden sm:block">{userName}</p>
        <img
          src="https://www.w3schools.com/howto/img_avatar.png"
          alt="profile"
          onClick={() => setIsDropdownOpen((prev) => !prev)}
          className="w-10 h-10 rounded-full border border-gray-300 object-cover cursor-pointer hover:scale-105 transition-transform"
        />

        {/* Dropdown */}
        {isDropdownOpen && (
          <div className="absolute right-0 top-12 bg-white border border-gray-200 rounded-lg shadow-lg w-40 z-50">
            <button
              onClick={handleProfile}
              className="w-full text-left px-4 py-2 hover:bg-gray-100 text-gray-700"
            >
              Profile
            </button>
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 hover:bg-gray-100 text-gray-700"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
